import dashboard from "../../api/dashboard";
import * as chartConfigs from "@/components/Charts/config";
import Chart from "chart.js";
import { percentageVieW } from "@/common/functions";
const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    dashbordaction: "",
    totalItems: 0,
    dashboardCounts: [],
    dashboardItems: {},
    welcomeDashboardItems: {},
    isWelcomeDashboard: false,
    openClickSummery: {},
    sendData: [],
    dashbordloaded: false,
    subscriberListCounts: [],
    showLifetimeSuccess: false,
    advancedCampaignOptions: false,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getDashBoardCounts: (state) => {
    var campaign = "";
    var performance = "";
    var listcounts = "";
    var openPer = 0;
    var clickPer = 0;
    var unsubPer = 0;

    if (state.dashboardCounts) {
      listcounts = state.dashboardCounts;
      campaign = state.dashboardCounts.camp_data;
      if (campaign) {
        openPer = percentageVieW(campaign.opens, campaign.send);
        clickPer = percentageVieW(campaign.clicks, campaign.opens);
        unsubPer = percentageVieW(campaign.unsub, campaign.opens);
      }
      performance = state.dashboardCounts.percentage;
    }
    return {
      openPer: openPer,
      clickPer: clickPer,
      unsubPer: unsubPer,
      campaign: campaign,
      performance: performance,
      listcounts: listcounts,
    };
  },
  getOpenClickPerformance: (state) => {
    var clicks = [];
    var maxdata = [];
    var opens = [];
    var labels = [];
    var nodata = 0;
    if (state.openClickSummery && state.loaded) {
      for (var key in state.openClickSummery) {
        nodata = nodata + parseInt(state.openClickSummery[key].opens);
        labels.push(state.openClickSummery[key].date_time);
        if (!state.dashbordaction) {
          opens.push(parseInt(state.openClickSummery[key].opens));
          // if (parseInt(state.openClickSummery[key].clicks) === parseInt(state.openClickSummery[key].opens)) {
          //   opens.push(0)
          // } else {
          //
          // }
          maxdata.push(
            parseInt(
              state.openClickSummery[key].opens +
                state.openClickSummery[key].clicks
            )
          );
          clicks.push(parseInt(state.openClickSummery[key].clicks));
        } else if (state.dashbordaction === "open") {
          opens.push(parseInt(state.openClickSummery[key].opens));
          maxdata.push(parseInt(state.openClickSummery[key].opens));
          clicks.push(0);
        } else if (state.dashbordaction === "click") {
          opens.push(0);
          maxdata.push(parseInt(state.openClickSummery[key].clicks));
          clicks.push(parseInt(state.openClickSummery[key].clicks));
        } else if (state.dashbordaction === "nodata") {
          opens.push(0);
          maxdata.push(0);
          clicks.push(0);
        }
      }
    }

    var limitarray = {
      1: 6,
      5: 30,
      20: 120,
      30: 180,
      50: 300,
      100: 600,
      60: 10000,
      70: 100000,
      80: 1000000,
      90: 10000000,
      101: 100000000,
      111: 1000000000,
    };

    if (nodata) {
      var maxOpenValue = Math.max.apply(Math, maxdata);
      maxOpenValue = parseInt(maxOpenValue / 20);

      var maxVal = 0;
      var maxkey = 0;
      for (var optionText in limitarray) {
        if (!maxVal && !maxkey) {
          if (limitarray[optionText] >= maxOpenValue) {
            maxVal = limitarray[optionText];
            maxkey = optionText;
          }
        }
      }
    }

    var num = 0;
    Chart.elements.Rectangle.prototype.draw = function () {
      num = num + 1;

      var ctx = this._chart.ctx;
      if (num === 1) {
        var chartOptn = this._chart;
        chartOptn.options.scales.yAxes[0].ticks.suggestedMin = parseInt(maxVal);
        chartOptn.options.scales.yAxes[0].ticks.suggestedMax = parseInt(maxVal);
        chartOptn.update();
      }

      var vm = this._view;
      var left, right, top, bottom, signX, signY, borderSkipped;
      var borderWidth = vm.borderWidth;
      // Set Radius Here
      // If radius is large enough to cause drawing errors a max radius is imposed
      var cornerRadius = 20;

      if (!vm.horizontal) {
        // bar
        left = vm.x - vm.width / 2;
        right = vm.x + vm.width / 2;
        top = vm.y;
        bottom = vm.base;
        signX = 1;
        signY = bottom > top ? 1 : -1;
        borderSkipped = vm.borderSkipped || "bottom";
      } else {
        // horizontal bar
        left = vm.base;
        right = vm.x;
        top = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
        signX = right > left ? 1 : -1;
        signY = 1;
        borderSkipped = vm.borderSkipped || "left";
      }

      // Canvas doesn't allow us to stroke inside the width so we can
      // adjust the sizes to fit if we're setting a stroke on the line
      if (borderWidth) {
        // borderWidth shold be less than bar width and bar height.
        var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
        borderWidth = borderWidth > barSize ? barSize : borderWidth;
        var halfStroke = borderWidth / 2;
        // Adjust borderWidth when bar top position is near vm.base(zero).
        var borderLeft =
          left + (borderSkipped !== "left" ? halfStroke * signX : 0);
        var borderRight =
          right + (borderSkipped !== "right" ? -halfStroke * signX : 0);
        var borderTop =
          top + (borderSkipped !== "top" ? halfStroke * signY : 0);
        var borderBottom =
          bottom + (borderSkipped !== "bottom" ? -halfStroke * signY : 0);
        // not become a vertical line?
        if (borderLeft !== borderRight) {
          top = borderTop;
          bottom = borderBottom;
        }
        // not become a horizontal line?
        if (borderTop !== borderBottom) {
          left = borderLeft;
          right = borderRight;
        }
      }

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = borderWidth;

      // Corner points, from bottom-left to bottom-right clockwise
      // | 1 2 |
      // | 0 3 |
      var corners = [
        [left, bottom],
        [left, top],
        [right, top],
        [right, bottom],
      ];

      // Find first (starting) corner with fallback to 'bottom'
      var borders = ["bottom", "left", "top", "right"];
      var startCorner = borders.indexOf(borderSkipped, 0);
      if (startCorner === -1) {
        startCorner = 0;
      }

      function cornerAt(index) {
        return corners[(startCorner + index) % 4];
      }
      var nextCornerId, width, height, x, y;

      var corner = cornerAt(0);
      ctx.moveTo(corner[0], corner[1]);

      for (var i = 1; i < 4; i++) {
        corner = cornerAt(i);
        nextCornerId = i + 1;
        if (nextCornerId === 4) {
          nextCornerId = 0;
        }

        // nextCorner = cornerAt(nextCornerId)

        width = corners[2][0] - corners[1][0];
        height = corners[0][1] - corners[1][1];
        x = corners[1][0];
        y = corners[1][1];

        var radius = cornerRadius;

        // Fix radius being too large
        if (radius > height / 2) {
          radius = height / 2;
        }
        if (radius > width / 2) {
          radius = width / 2;
        }

        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(
          x + width,
          y + height,
          x + width - radius,
          y + height
        );
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
      }

      ctx.fill();
      if (borderWidth) {
        ctx.stroke();
      }
    };

    var redBarChart = {
      chartData: {
        labels: labels,
        datasets: [
          {
            label: "Opens",
            data: opens,
            backgroundColor: "#03045E",
            borderWidth: 0,
          },
          {
            label: "Clicks",
            data: clicks,
            backgroundColor: "#0096C7",
            borderWidth: 0,
          },
        ],
      },
      extraOptions: chartConfigs.barChartOptions,
    };

    return { chart: redBarChart, nodata: nodata };
  },

  getSentContGraph: (state) => {
    var sentto = [];
    var labels = [];
    var nodata = 0;

    if (state.sendData && state.loaded) {
      for (var key in state.sendData) {
        nodata = nodata + state.sendData[key].sentto;
        sentto.push(parseInt(state.sendData[key].sentto));
        labels.push(state.sendData[key].date_time);
      }
    }

    return { sentto: sentto, labels: labels, nodata: nodata };
  },

  getDashbordItems: (state) => {
    var autoresponderCount = 0;
    var autoresponderReportCount = 0;
    var campignCount = 0;
    var campignReportCount = 0;
    var listCount = 0;
    var segmntCount = 0;
    var time = "";
    var templateCount = 0;
    if (state.dashboardItems && Object.keys(state.dashboardItems).length) {
      autoresponderCount = parseInt(state.dashboardItems.autoresponderCount);
      autoresponderReportCount = parseInt(
        state.dashboardItems.autoresponderReportCount
      );
      campignCount = parseInt(state.dashboardItems.campignCount);
      listCount = parseInt(state.dashboardItems.listCount);
      segmntCount = parseInt(state.dashboardItems.segmntCount);
      templateCount = parseInt(state.dashboardItems.templateCount);
      time = state.dashboardItems.current_datetime;
    }

    return {
      clent_curTime: time,
      templateCount: templateCount,
      segmntCount: segmntCount,
      listCount: listCount,
      campignReportCount: campignReportCount,
      autoresponderCount: autoresponderCount,
      autoresponderReportCount: autoresponderReportCount,
      campignCount: campignCount,
    };
  },
};

// actions
const actions = {
  fetchDashBoardItems({ commit }, params) {
    dashboard.fetchDashBoardItems(params, (data) => {
      commit("setDashboardCount", { items: data.items });
    });
  },
  fetchPeformanceGraph({ commit }, params) {
    dashboard.fetchPeformanceGraph(params, (data) => {
      commit("setOpenClickSummery", { items: data.items.report });
      commit("setLoaded", true);
    });
  },
  fetchSendCountGraph({ commit }, params) {
    dashboard.fetchSendCountGraph(params, (data) => {
      commit("setSentGraph", { items: data.items });
    });
  },
  getAllCounts({ commit, state }) {
    if (!state.dashbordloaded) {
      dashboard.getAllCounts("", (data) => {
        commit("setDashbordItems", { items: data.items });
        commit("setDashbordLoaded", true);
      });
    }
  },

  getWelcomeDashboard({ commit }) {
    if (parseInt(localStorage.getItem("is_campaign_add")) !== 2) {
      dashboard.getWelcomeDashboard("", (data) => {
        commit("setWelcomeDashboardItems", { items: data.items });
      });
    }
  },

  resetState({ commit }) {
    commit("resetState");
  },
  getListCounts({ commit, state }) {
    if (!state.dashbordloaded) {
      dashboard.getListCounts("", (data) => {
        commit("setSubscriberListCounts", { items: data.data });
      });
    }
  },
};

// mutations
const mutations = {
  setLoaded(state, val) {
    state.loaded = val;
  },
  setDashbordAction(state, val) {
    state.dashbordaction = val;
  },
  setDashboardCount(state, { items }) {
    state.dashboardCounts = items;
  },
  setOpenClickSummery(state, { items }) {
    state.openClickSummery = items;
  },
  setSentGraph(state, { items }) {
    state.sendData = items;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setDashbordItems(state, { items }) {
    state.dashboardItems = items;
  },
  setWelcomeDashboardItems(state, { items }) {
    state.welcomeDashboardItems = items;
    window.localStorage.setItem("welcomeDashboardItems", JSON.stringify(items));
    state.isWelcomeDashboard = items.addCampaign;
    window.localStorage.setItem("isWelcomeDashboard", state.isWelcomeDashboard);
  },
  setIsWelcomeDashboard(state, val) {
    state.isWelcomeDashboard = val;
    window.localStorage.setItem("isWelcomeDashboard", state.isWelcomeDashboard);
  },
  setDashbordLoaded(state, loaded) {
    state.dashbordloaded = loaded;
  },
  setSubscriberListCounts(state, { items }) {
    state.subscriberListCounts = items;
  },
  setShowLifetimeSuccess(state, status) {
    var stateval = state;
    stateval.showLifetimeSuccess = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
